module.exports = __webpack_public_path__ + "img/Ciencia Ficción.4f8ba4d2.svg";